import { render, staticRenderFns } from "./OrderResourceView.vue?vue&type=template&id=120d3dc1&scoped=true"
import script from "./OrderResourceView.vue?vue&type=script&lang=js"
export * from "./OrderResourceView.vue?vue&type=script&lang=js"
import style0 from "./OrderResourceView.vue?vue&type=style&index=0&id=120d3dc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120d3dc1",
  null
  
)

export default component.exports